module.exports = __webpack_public_path__ + "static/media/sandwich-512.52d97a60.png";